<template>
  <div class="checklist__item-control">
    <!-- template drag&drop icon -->
    <span v-if="isEditable" class="checklist__item-icon checklist__control-icon--draggable">
      <img :src="dragIcon" />
    </span>
    <!-- pending task icon -->
    <AppIcon
      v-else-if="!isTemplatePage && !isUserTask && !isItemCompleted"
      class="checklist__item-icon checklist__item-icon--task"
      icon="far fa-hourglass-half"
    />
    <!-- task checkbox -->
    <AppCheckbox
      v-else
      v-model="item.is_completed"
      :disabled="isItemDisabled"
      @input="prepareValues"
    />
  </div>
</template>

<script>
// Utilities
import ChecklistsMixin from '../mixins'
import DragIcon from 'Images/svg/drag-icon.svg'
// Components
import AppIcon from 'Ui/AppIcon'
import AppCheckbox from 'Ui/AppCheckbox'

export default {
  name: 'ChecklistsChecklistItemControl',

  props: {
    item: {
      type: Object,
      required: true,
    },

    disabled: {
      type: Boolean,
      required: true,
    },
  },

  components: {
    AppIcon,
    AppCheckbox,
  },

  mixins: [ChecklistsMixin],

  data() {
    return {
      timeout: null,
    }
  },

  methods: {
    prepareValues(value) {
      if (this.isItemDisabled) return
      const newData = {
        is_completed: value,
      }
      // preparing requested values for API call
      const itemInfo = this.getChecklistData({
        checklistId: this.item.checklist,
        itemId: this.item.id,
        newData: newData,
      })
      this.updateStatus(itemInfo)
    },

    updateStatus(itemInfo) {
      this.$emit('status-changed', itemInfo)
    },
  },

  computed: {
    dragIcon() {
      return DragIcon
    },

    isItemCompleted() {
      return this.item.is_completed
    },

    isItemDisabled() {
      return this.isDetailPage || this.disabled || (this.isItemCompleted && !this.isUserTask)
    },
  },
}
</script>

<style scoped>
.checklist__item-control {
  display: flex;
  padding-top: 5px;
}

.checklist__item--editing .checklist__item-control {
  padding-top: 8px;
}

.checklist__item-control >>> .app-checkbox {
  margin-right: 0;
}

.checklist__item-icon--task {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 19px;
  height: 19px;
  font-size: 11px;
  color: var(--c-secondary);
  border-radius: 2px;
  background-color: var(--c-secondary-400);
}
</style>
